import React, { Component } from 'react'
import RadioGroupMeal from '../CustomButtons/RadioGroupMeal'
import PropTypes from 'prop-types' //eslint-disable-line


class Eat extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selected: '',
    }
  }

  componentWillMount = () => {
    if (this.props.info.eat) {
      this.setState({ selected: this.props.info.eat })
    }
  }

  setInfo = (id, name) => {
    const nextState = { ...this.props.info }
    nextState[name] = id
    this.setState(nextState, () => this.props.setExtraData(nextState))
  }

  render() {
    return (
      <RadioGroupMeal
        setInfo={this.setInfo}
        goToView={this.props.goToView}
        child={this.props.child}
        group={this.props.group}
        setExtraData={this.props.setExtraData}
        info={this.props.info}
        category={this.props.category}
        selected={this.state.selected}
      >
        <div type="Nada" name="eat" label="1" />
        <div type="Casi nada" name="eat" label="2" />
        <div type="La mitad" name="eat" label="3" />
        <div type="Casi Todo" name="eat" label="4" />
        <div type="Todo" name="eat" label="5" />
      </RadioGroupMeal>
    )
  }
}

Eat.propTypes = {
  goToView: PropTypes.func.isRequired,
  setExtraData: PropTypes.func.isRequired,
  info: PropTypes.object,
  child: PropTypes.object,
}

Eat.defaultProps = {
  child: {},
  info: {},
}

export default Eat



// WEBPACK FOOTER //
// ./src/Components/Activity/Eat.jsx